/* LQK Israk Mikraj — a gentle night-flight game.
 * Guide the radiant steed through the golden gates, collect the stars.
 * Forgiving by design (ages 3-12): bumping a gate costs one heart and a
 * moment of dizziness, never an instant game-over.
 * Depends on lqk-games-kit.js (window.LQKG).
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-lqkg-israk]');
  if (!root || !window.LQKG) return;
  var K = window.LQKG;

  var stage = root.querySelector('[data-stage]');
  var canvas = root.querySelector('canvas');
  var g = canvas.getContext('2d');
  var cover = root.querySelector('[data-cover]');
  var startBtn = root.querySelector('[data-start]');
  var starsEl = root.querySelector('[data-stars]');
  var heartsEl = root.querySelector('[data-hearts]');
  var levelBtns = root.querySelectorAll('.lqkg__level');
  K.soundButton(root.querySelector('[data-sound]'));
  var win = K.modal(root);

  var SPRITES = JSON.parse(root.getAttribute('data-sprites'));
  var IMG = {};
  Object.keys(SPRITES).forEach(function (k) {
    IMG[k] = new Image();
    IMG[k].src = K.asset(SPRITES[k]);
  });
  // if the kit finishes preloading after us, refresh to the blob copies
  K.preload(Object.keys(SPRITES).map(function (k) { return SPRITES[k]; })).then(function () {
    Object.keys(SPRITES).forEach(function (k) { IMG[k].src = K.asset(SPRITES[k]); });
  });

  var LEVELS = [
    { gapFrac: 0.44, speed: 0.16, gravity: 1150, flap: -380, every: 2.9 }, // Gentle
    { gapFrac: 0.36, speed: 0.22, gravity: 1350, flap: -420, every: 2.4 }, // Brave
  ];
  var GOAL = 12, level = 0;

  var W = 0, H = 0, dpr = 1;
  function resize() {
    var r = stage.getBoundingClientRect();
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = r.width; H = r.height;
    canvas.width = W * dpr; canvas.height = H * dpr;
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  window.addEventListener('resize', resize);
  resize();

  var playing = false, buraq, gates, stars, sparkles, skylineX, collected, hearts,
    lastT, flapPhase, dizzyUntil, safeUntil, spawnAt, raf;

  function reset() {
    buraq = { x: W * 0.24, y: H * 0.45, vy: 0 };
    gates = []; stars = []; sparkles = [];
    skylineX = 0; collected = 0; hearts = 3;
    flapPhase = 0; dizzyUntil = 0; safeUntil = 0; spawnAt = 1.4;
    lastT = null;
    hud();
  }
  function hud() {
    starsEl.textContent = collected + '/' + GOAL;
    heartsEl.innerHTML = hearts ? K.icon('heart').repeat(hearts) : '—';
  }

  function spawnGate() {
    var L = LEVELS[level];
    var gap = H * L.gapFrac;
    var gapY = H * 0.18 + Math.random() * (H * 0.64 - gap);
    var w = Math.max(64, W * 0.16);
    gates.push({ x: W + w, w: w, top: gapY, bottom: gapY + gap, passed: false });
    // a star floats in (or near) the gap
    stars.push({ x: W + w + W * 0.32, y: gapY + gap * (0.25 + Math.random() * 0.5), r: Math.max(18, W * 0.045), got: false, tw: Math.random() * 6 });
  }

  function flap() {
    if (!playing) return;
    var now = performance.now() / 1000;
    if (now < dizzyUntil) return;
    buraq.vy = LEVELS[level].flap * (H / 560);
    flapPhase = 0.22;
    K.sound.tap();
  }
  stage.addEventListener('pointerdown', function (e) { e.preventDefault(); flap(); });
  document.addEventListener('keydown', function (e) {
    if ((e.key === ' ' || e.key === 'ArrowUp') && playing) { e.preventDefault(); flap(); }
  });

  function bump() {
    var now = performance.now() / 1000;
    if (now < safeUntil) return;
    hearts--; hud();
    dizzyUntil = now + 1.0;
    safeUntil = now + 2.2;
    K.sound.buzz(); K.vibrate(80);
    if (hearts <= 0) {
      playing = false;
      win.show({
        title: 'So close!', stars: 1,
        text: 'You collected ' + collected + ' star' + (collected === 1 ? '' : 's') + '. Bismillah, try again!',
        againLabel: 'Fly again',
        onAgain: start,
      });
    }
  }

  function step(t) {
    if (!playing) return;
    if (W < 10 || H < 10) { resize(); if (buraq.y < 1) buraq.y = H * 0.45; }
    if (lastT == null) lastT = t;
    var dt = Math.min(0.033, (t - lastT) / 1000);
    lastT = t;
    var L = LEVELS[level], now = t / 1000;
    var speed = W * L.speed * dt * 60 / 16.7 * 16.7; // px/s expressed per-frame below
    var vx = W * L.speed; // px/s horizontal world speed

    // physics
    buraq.vy += L.gravity * (H / 560) * dt;
    buraq.y += buraq.vy * dt;
    flapPhase = Math.max(0, flapPhase - dt);
    if (buraq.y < H * 0.04) { buraq.y = H * 0.04; buraq.vy = 0; }
    if (buraq.y > H * 0.9) { buraq.y = H * 0.9; buraq.vy = LEVELS[level].flap * 0.5 * (H / 560); bump(); }

    // world scroll
    skylineX = (skylineX - vx * 0.25 * dt) % W;
    spawnAt -= dt;
    if (spawnAt <= 0) { spawnGate(); spawnAt = L.every; }
    gates.forEach(function (gt) { gt.x -= vx * dt; });
    stars.forEach(function (s) { s.x -= vx * dt; s.tw += dt * 4; });
    gates = gates.filter(function (gt) { return gt.x + gt.w > -10; });
    stars = stars.filter(function (s) { return s.x > -60 && !s.got; });
    sparkles.forEach(function (p) { p.x += p.vx * dt; p.y += p.vy * dt; p.a -= dt * 1.6; });
    sparkles = sparkles.filter(function (p) { return p.a > 0; });

    // collisions
    var bw = Math.max(52, W * 0.14), bh = bw * 0.62;
    var bx = buraq.x - bw / 2, by = buraq.y - bh / 2;
    gates.forEach(function (gt) {
      if (bx + bw * 0.8 > gt.x && bx + bw * 0.2 < gt.x + gt.w) {
        if (by + bh * 0.25 < gt.top || by + bh * 0.75 > gt.bottom) bump();
        else if (!gt.passed && bx > gt.x + gt.w * 0.5) { gt.passed = true; }
      }
    });
    stars.forEach(function (s) {
      var dx = s.x - buraq.x, dy = s.y - buraq.y;
      if (dx * dx + dy * dy < (s.r + bw * 0.35) * (s.r + bw * 0.35)) {
        s.got = true; collected++; hud(); K.sound.ding();
        for (var i = 0; i < 10; i++) sparkles.push({ x: s.x, y: s.y, vx: (Math.random() - 0.5) * 160, vy: (Math.random() - 0.5) * 160, a: 1 });
        if (collected >= GOAL) {
          playing = false;
          K.confetti(); K.sound.win();
          win.show({
            title: 'Mumtaz!', stars: 3,
            text: 'You collected all ' + GOAL + ' stars on the night journey!',
            againLabel: 'Fly again', onAgain: start,
          });
        }
      }
    });

    draw(now);
    raf = requestAnimationFrame(step);
  }

  function draw(now) {
    g.clearRect(0, 0, W, H);

    // skyline (two copies for a seamless loop), pinned to the bottom
    var sk = IMG.skyline;
    if (sk.complete && sk.naturalWidth) {
      var sh = H * 0.22, sw = sh * (sk.naturalWidth / sk.naturalHeight);
      for (var x = skylineX - sw; x < W + sw; x += sw) g.drawImage(sk, x, H - sh, sw, sh);
    }

    // gates
    gates.forEach(function (gt) {
      var top = IMG.gateTop, bot = IMG.gateBottom;
      if (top.complete && top.naturalWidth) {
        var thTop = gt.top, wTop = gt.w;
        g.drawImage(top, gt.x, gt.top - wTop * (top.naturalHeight / top.naturalWidth), wTop, wTop * (top.naturalHeight / top.naturalWidth));
        var ratioB = bot.naturalHeight / bot.naturalWidth;
        g.drawImage(bot, gt.x, gt.bottom, gt.w, gt.w * ratioB);
      } else {
        g.fillStyle = '#e0a93b';
        g.fillRect(gt.x, 0, gt.w, gt.top);
        g.fillRect(gt.x, gt.bottom, gt.w, H - gt.bottom);
      }
    });

    // stars
    stars.forEach(function (s) {
      var im = IMG.star, pulse = 1 + Math.sin(s.tw) * 0.08;
      if (im.complete && im.naturalWidth) {
        var d = s.r * 2 * pulse;
        g.drawImage(im, s.x - d / 2, s.y - d / 2, d, d);
      }
    });

    // sparkles
    sparkles.forEach(function (p) {
      g.globalAlpha = Math.max(0, p.a);
      g.fillStyle = '#ffd97a';
      g.beginPath(); g.arc(p.x, p.y, 3, 0, Math.PI * 2); g.fill();
      g.globalAlpha = 1;
    });

    // buraq
    var dizzy = now < dizzyUntil, safe = now < safeUntil;
    var frame = dizzy ? IMG.dizzy : (flapPhase > 0 ? IMG.up : IMG.down);
    var bw = Math.max(52, W * 0.14), bh = bw * (frame.naturalHeight && frame.naturalWidth ? frame.naturalHeight / frame.naturalWidth : 0.75);
    var tilt = Math.max(-0.35, Math.min(0.5, buraq.vy / 900));
    g.save();
    g.translate(buraq.x, buraq.y);
    g.rotate(dizzy ? Math.sin(now * 10) * 0.1 : tilt);
    if (safe && !dizzy) g.globalAlpha = 0.55 + Math.sin(now * 18) * 0.25;
    if (frame.complete && frame.naturalWidth) g.drawImage(frame, -bw / 2, -bh / 2, bw, bh);
    g.restore();
    g.globalAlpha = 1;
  }

  function start() {
    cover.setAttribute('data-open', 'false');
    resize(); // the page may have loaded in a hidden/background tab where the stage measured 0x0
    reset();
    playing = true;
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(step);
  }
  startBtn.addEventListener('click', start);

  levelBtns.forEach(function (b, i) {
    b.addEventListener('click', function () {
      level = i;
      levelBtns.forEach(function (x, j) { x.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      K.sound.tap();
      if (playing) start();
    });
  });
})();
